import { matchPath, type LoaderFunction, type ShouldRevalidateFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  GetTriggerDefinitionDocument,
  GetTriggerDefinitionQuery,
  GetTriggerDefinitionQueryVariables,
  GetTriggerDefinitionsDocument,
  GetTriggerDefinitionsQuery,
  GetTriggerDefinitionsQueryVariables,
  TriggerDefinitionFieldsFragment
} from '~/api/graphql';

export const getTriggerDefinitions = () =>
  queryData<
    GetTriggerDefinitionsQuery,
    GetTriggerDefinitionsQueryVariables,
    TriggerDefinitionFieldsFragment[]
  >(client, { query: GetTriggerDefinitionsDocument }, (data) => data?.triggerDefinitions || []);

// Network-only: the update is rejected if it carries a stale cached version.
export const getTriggerDefinition = (id: string) =>
  queryData<
    GetTriggerDefinitionQuery,
    GetTriggerDefinitionQueryVariables,
    TriggerDefinitionFieldsFragment
  >(
    client,
    { query: GetTriggerDefinitionDocument, variables: { id }, fetchPolicy: 'network-only' },
    (data) => data?.triggerDefinition
  );

export const loadTriggerDefinitions: LoaderFunction = () =>
  loadQuery(getTriggerDefinitions(), { suppressAuthErrors: true });

export const loadTriggerDefinition: LoaderFunction = ({ params }) =>
  loadQuery(getTriggerDefinition(params.triggerId || ''), {
    notFoundRedirect: '/app/workflows/triggers'
  });

// The slideouts pause, resume, and delete through Apollo, which the list's
// loader snapshot does not observe, so closing one re-reads the list.
export const shouldRevalidateTriggerList: ShouldRevalidateFunction = ({
  currentUrl,
  nextUrl,
  defaultShouldRevalidate
}) =>
  defaultShouldRevalidate ||
  (currentUrl.pathname !== nextUrl.pathname &&
    !!matchPath('/app/workflows/triggers', nextUrl.pathname));
